export const computerScienceEnggData = {
  departmentName: "Department of Computer Science & Engineering",
  bannerImage: "/infrastructure/cse/lab-1.JPG",
  
  about: {
    title: "About the Department",
    content: `The Department of Computer Science & Engineering at Rayalaseema University is at the forefront of 
    technological education and innovation. Our comprehensive programs cover software engineering, computer networks, 
    database systems, artificial intelligence, machine learning, cloud computing, and cybersecurity. We emphasize 
    both theoretical foundations and practical applications, preparing students for successful careers in the dynamic 
    IT industry.`,
    highlights: [
      "State-of-the-art computer laboratories with latest hardware and software",
      "Focus on emerging technologies: AI, ML, Cloud Computing, IoT",
      "Industry partnerships and internship opportunities with leading tech companies",
      "Active coding clubs and participation in hackathons"
    ]
  },

  brochure: {
    title: "Department Brochure",
    pdfLink: "/computerscienceengg/department-brochure.pdf",
    description: "Download our comprehensive department brochure for detailed information about programs, facilities, and achievements."
  },

  hod: {
    id:'ai001',
    name: "V.SATISH KUMAR ",
    designation: "Co-ordinator & Assistant Professor(AD HOC) ",
    photo: "/artificialintelligence/sathis.JPG",
    email: "valmikisatish71@gmail.com ",
    mobile: "+91 9866248428 ",
    qualification: "B.Tech, M.Tech, Ph.D (Pursuing) ",
    specialization: "COMPUTER NETWORKS, ARTIFICIAL INTELLIGENCE, MACHINE LEARNING",
    message: `Welcome to the Department of Computer Science & Engineering. We are committed to nurturing the next 
    generation of computer scientists and engineers who can innovate and lead in the ever-evolving world of technology. 
    Our programs are designed to provide a strong foundation while keeping pace with industry trends.`,
    profileLink: "/artificialintelligence/sathis.pdf"
  },

  bos: {
    title: "Board of Studies",
    members: [
      // {
      //   name: "Prof. Raghava Rao",
      //   designation: "Chairman",
      //   affiliation: "Rayalaseema University"
      // },
      // {
      //   name: "Dr. Sowmya Devi",
      //   designation: "Member",
      //   affiliation: "Rayalaseema University"
      // },
      // {
      //   name: "Dr. Kiran Kumar",
      //   designation: "Member",
      //   affiliation: "Rayalaseema University"
      // },
      // {
      //   name: "Prof. External Expert",
      //   designation: "External Member",
      //   affiliation: "Tech Industry"
      // }
    ]
  },

  faculty: [
    {
      id:'ai001',
     name: "V.SATISH KUMAR ",
    designation: "Co-ordinator & Assistant Professor(AD HOC) ",
    photo: "/artificialintelligence/sathis.JPG",
    email: "valmikisatish71@gmail.com ",
    mobile: "+91 9866248428 ",
    qualification: "B.Tech, M.Tech, Ph.D (Pursuing) ",
    specialization: "COMPUTER NETWORKS, ARTIFICIAL INTELLIGENCE, MACHINE LEARNING",
     profileLink: "/artificialintelligence/sathis.pdf"
    }
  ],

  courses: {
    undergraduate: [
      {
        name: "B.Tech Computer Science & Engineering",
        duration: "4 Years",
        eligibility: "10+2 with Physics, Chemistry, and Mathematics",
        intake: "180 seats"
      }
    ],
    // postgraduate: [
    //   {
    //     name: "M.Tech Computer Science & Engineering",
    //     duration: "2 Years",
    //     eligibility: "B.E./B.Tech in CSE or related field",
    //     intake: "30 seats"
    //   },
    //   {
    //     name: "M.Tech Artificial Intelligence",
    //     duration: "2 Years",
    //     eligibility: "B.E./B.Tech in CSE or related field",
    //     intake: "30 seats"
    //   }
    // ],
    // research: [
    //   {
    //     name: "Ph.D. in Computer Science & Engineering",
    //     duration: "Minimum 3 Years",
    //     eligibility: "M.Tech with qualifying exam",
    //     areas: "Artificial Intelligence, Machine Learning, Cloud Computing, Cybersecurity, Data Science, IoT"
    //   }
    // ]
  },

  Infrastructure: [
    
    "/infrastructure/cse/class-2.JPG",
    "/infrastructure/cse/class-1.JPG",

    "/infrastructure/cse/lab-1.JPG",
    "/infrastructure/cse/lab-2.JPG",
    "/infrastructure/cse/lab-3.JPG",
   

  ]
};
